import { Routes, Route } from '@angular/router';

import { Injectable } from '@angular/core';
import { ShellComponent } from './shell.component';
import { authGuard } from '@app/features/auth/guards';

// import { authGuard } from '@app/features/auth/guards';

@Injectable({
  providedIn: 'root',
})
export class Shell {
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      children: routes,
      component: ShellComponent,
      canActivate: [authGuard],
    };
  }
}